import { Controller } from "stimulus"
import printJS from 'print-js'

export default class extends Controller {
  static targets = ["button", "content", "icon", "spinner", "text"]
  print(event) {
    event.preventDefault();

    // Check if running in Hotwire Native iOS app and use native bridge
    if (window.NativeBridge) {
      // Show loading state
      this.showLoading();
      
      try {
        const result = window.NativeBridge.postMessage({
          action: 'printDialog',
          url: this.element.dataset.pdfUrl,
          loadingText: this.element.dataset.loadingText
        });
        // Hide loading after a short delay to allow dialog to open
        setTimeout(() => {
          this.hideLoading();
        }, 1000);
        
      } catch (error) {
        console.error("🖨️ [PrinterController] NativeBridge error:", error);
        this.hideLoading();
      }
      return;
    }

    var element = this.element
    if (this.element.dataset.model == 'Package' && this.element.dataset.printingTemplateName == 'box_label') {
      var afterPreviewClose = function(){
        // Reload the page, thinks a better way to do this
        Turbo.visit(location.toString());
      };

      printJS({
        printable: this.element.dataset.pdfUrl,
        type: 'pdf',
        showModal: true,
        modalMessage: this.element.dataset.loadingText,
        onPrintDialogClose: afterPreviewClose
      })
    } else {
      printJS({
        printable: this.element.dataset.pdfUrl,
        type: 'pdf',
        showModal: true,
        modalMessage: this.element.dataset.loadingText
      })

    }
  }

  showLoading() {

    // Use direct DOM queries for standard UI pattern
    const icon = this.element.querySelector('[data-printer-target="icon"]');
    const spinner = this.element.querySelector('[data-printer-target="spinner"]');
    const text = this.element.querySelector('[data-printer-target="text"]');

    // Hide printer icon and show spinner
    if (icon) {
      icon.classList.add('hidden');
    }
    if (spinner) {
      spinner.classList.remove('hidden');
    }
    if (text) {
      text.textContent = 'Printing...';
    }
    
    // Disable button to prevent multiple clicks
    this.element.style.pointerEvents = 'none';
    this.element.classList.add('opacity-75');
    
    // Set up focus/blur detection for dialog closing
    this.setupDialogDetection();
  }

  hideLoading() {
    // Use direct DOM queries for standard UI pattern
    const icon = this.element.querySelector('[data-printer-target="icon"]');
    const spinner = this.element.querySelector('[data-printer-target="spinner"]');
    const text = this.element.querySelector('[data-printer-target="text"]');
    
    // Show printer icon and hide spinner
    if (icon) {
      icon.classList.remove('hidden');
    }
    if (spinner) {
      spinner.classList.add('hidden');
    }
    if (text) {
      text.textContent = 'Print Receipt';
    }
    
    // Re-enable button
    this.element.style.pointerEvents = 'auto';
    this.element.classList.remove('opacity-75');
    
    // Clean up dialog detection
    this.cleanupDialogDetection();
  }

  setupDialogDetection() {
    // Store original focus state
    this.originalActiveElement = document.activeElement;
    
    // Set up window focus/blur detection
    this.windowBlurHandler = () => {
      this.dialogOpenTime = Date.now();
    };
    
    this.windowFocusHandler = () => {
      if (this.dialogOpenTime && (Date.now() - this.dialogOpenTime) > 500) {
        this.hideLoading();
      }
    };
    
    // Set up visibility change detection
    this.visibilityChangeHandler = () => {
      if (document.hidden) {
        this.dialogOpenTime = Date.now();
      } else {
        if (this.dialogOpenTime && (Date.now() - this.dialogOpenTime) > 500) {
          this.hideLoading();
        }
      }
    };
    
    // Add event listeners
    window.addEventListener('blur', this.windowBlurHandler);
    window.addEventListener('focus', this.windowFocusHandler);
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    
    // Fallback timeout in case detection fails
    this.fallbackTimeout = setTimeout(() => {
      this.hideLoading();
    }, 3000);
  }

  cleanupDialogDetection() { 
    if (this.windowBlurHandler) {
      window.removeEventListener('blur', this.windowBlurHandler);
    }
    if (this.windowFocusHandler) {
      window.removeEventListener('focus', this.windowFocusHandler);
    }
    if (this.visibilityChangeHandler) {
      document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    }
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
    }

    // Reset state
    this.dialogOpenTime = null;
    this.originalActiveElement = null;
  }
}
